import React from 'react';
import About from '../components/About';
import Contact from '../components/Contact';

const AboutPage: React.FC = () => {
  return (
    <main>
      <About />
      <Contact />
    </main>
  );
};

export default AboutPage; 